<mat-form-field>
  <mat-label>{{label}}</mat-label>
  <mat-date-range-input [formGroup]="dateRange" [rangePicker]="picker" [min]="minDate" [max]="maxDate">
    <input matStartDate formControlName="start" placeholder="Start date" (dateChange)="onDateChange('start', $event)">
    <input matEndDate formControlName="end" placeholder="End date" (dateChange)="onDateChange('end', $event)">
  </mat-date-range-input>
  <mat-hint *ngIf="hint">{{hint}}</mat-hint>
  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-date-range-picker #picker></mat-date-range-picker>
  
  <button *ngIf="dateRange.value.start || dateRange.value.end"
          mat-icon-button matSuffix (click)="clearDateRange()">
    <mat-icon>close</mat-icon>
  </button>
  
  <mat-error *ngIf="dateRange.controls.start.hasError('matStartDateInvalid')">Invalid start date</mat-error>
  <mat-error *ngIf="dateRange.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>
</mat-form-field>